var render = function render(){var _vm=this,_c=_vm._self._c;return _c('observer',{on:{"on-change":_vm.onChange}},[_c('section',{class:{ 'show': _vm.visible, 'hidden': !_vm.visible }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }